/**
 * Shared dispatch tab rules (keep in sync with DispatchScreen tab filters).
 */

export function isDoorDeliveryOrder(order) {
  return order?.deliveryFeeType === 'deliver_to_door' || order?.deliveryFeeType === 'delivery_to_door';
}

function getResolvedEntryInstructions(order) {
  return String(
    order?.entryInstructions ||
    order?.property?.description ||
    ''
  ).trim();
}

export function hasDispatchEntryInstructions(order) {
  if (order?.needsEntryInstructions === true) return false;
  if (order?.hostOrderDetailsInputted === true) return true;
  return Boolean(getResolvedEntryInstructions(order));
}

export function hasDispatchDeliveryTime(order) {
  if (isDoorDeliveryOrder(order)) return true;
  if (order?.needsDeliveryTime === true) return false;
  return Boolean(order?.storeArrivalTime || order?.hostSetDeliveryTime);
}

export function needsDispatchEntryInstructions(order) {
  return !hasDispatchEntryInstructions(order);
}

export function needsDispatchDeliveryTime(order) {
  return !hasDispatchDeliveryTime(order);
}

export function needsDispatchAttention(order) {
  return needsDispatchEntryInstructions(order) || needsDispatchDeliveryTime(order);
}

/**
 * Assign Driver tab: pending or requested, store order placed, driver pay set,
 * and no driver on the resolved parent order (main order or add-on parent).
 *
 * @param {object} order
 * @param {object[]} allOrders - Full list for originalOrderId → parent lookup
 */
export function isAssignDriverOrder(order, allOrders = []) {
  if (isDoorDeliveryOrder(order)) return false;
  if (order.status !== 'pending' && order.status !== 'requested') return false;

  const spend = parseFloat(order.storeSpend);
  if (isNaN(spend) || spend <= 0) return false;

  const pay = parseFloat(order.driverPay);
  if (isNaN(pay) || pay <= 0) return false;

  if (!order.storeOrderId?.trim()) return false;

  const parent = order.originalOrderId
    ? allOrders.find((p) => String(p._id) === String(order.originalOrderId))
    : null;
  const resolved = parent || order;
  return !resolved.driverID;
}
